import { ref, computed } from 'vue';
import { useAuthentication } from '@/.shared/services/auth';
import logoDefault from '@/assets/images/logo-processus.svg';

const logoRefreshTrigger = ref(0);
const logoTimestamp = ref(Date.now());

export function useLogoStore() {
  const auth = useAuthentication();

  const logoUrl = computed(() => {
    logoRefreshTrigger.value;
    
    const baseUrl = import.meta.env.VITE_API_BASE_URL;
    const idEmpresaAgentes = auth.userInfo?.idEmpresaAgentes;
    
    if (!idEmpresaAgentes) {
      return logoDefault;
    }
    
    return `${baseUrl}/api/Operaciones/EmpresaAgentes/${idEmpresaAgentes}/logo-portal?t=${logoTimestamp.value}`;
  });

  const refreshLogo = () => {
    logoTimestamp.value = Date.now();
    logoRefreshTrigger.value++;
  };

  return {
    logoUrl,
    refreshLogo
  };
}